<script lang="ts">
	import { format } from 'svelte-i18n';
	import { DropdownMenu, MenuItemList } from '@Shelly/shelly-design-system';
	import TabsActionsButton from 'src/components/TabsActionsButton.svelte';
	import { energyWidgetPreviewState, type EnergyWidgetPreviewState } from './v2/all-energy-widgets';

	let showDropdown = false;

	const states: Array<{
		id: EnergyWidgetPreviewState;
		label: string;
		icon: string;
	}> = [
		{ id: 'live', label: 'Live data', icon: 'fas fa-wave-pulse' },
		{ id: 'sample', label: 'Sample data', icon: 'fas fa-chart-line' },
		{ id: 'empty', label: 'Nothing to display', icon: 'fas fa-pause' },
		{ id: 'setup', label: 'Setup needed', icon: 'fas fa-gear' },
		{ id: 'partial', label: 'Partial setup', icon: 'fas fa-circle-half-stroke' },
		{ id: 'error', label: 'Error with retry', icon: 'fas fa-triangle-exclamation' },
	];

	const selectState = (state: EnergyWidgetPreviewState) => {
		energyWidgetPreviewState.set(state);
		showDropdown = false;
	};
</script>

<DropdownMenu bind:show={showDropdown}>
	<TabsActionsButton
		slot="trigger"
		variant="help-2"
		isActive={showDropdown}
		ariaLabel={$format('energy_widget_gallery_state_control', {
			default: 'Change energy widget preview state',
		})}
		on:click={() => (showDropdown = !showDropdown)}
	/>

	<MenuItemList
		isGroupTitle
		size="m"
		title={$format('energy_widget_gallery_state_title', { default: 'Widget state' })}
	/>
	{#each states as state (state.id)}
		<MenuItemList
			isGroupItem
			isSelectable
			size="m"
			icon={state.icon}
			title={state.label}
			selected={state.id === $energyWidgetPreviewState}
			on:click={() => selectState(state.id)}
		/>
	{/each}
</DropdownMenu>
